
export class AmountInvestedModel {
    AmountInvestedInUSD: any = '0';
    BCHContributed: any = 0;
    BTCContributed: any = '0';
    BTGContributes: any = 0;
    DASHContributes: any = 0;
    EARNTokenBalance: any = '0';
    ETHContributed: any = '0';
    Email: any = 0;
    LTCContributed: any = '0';
    NEOContributes: any = 0;
    Name: any = 0;
    TokenBalance: any = '0';
    MXNContributed: any = '0';
    // MXNPContributed: any = 0;
    USDContributed: any = '0';
    USDContributes: any = 0;
    USDT_BNBContributed: any = '0';
    USDT_ETHContributed: any = '0';
    USDT_TRONContributed: any = '0';
    // New contributions (backend should populate these when available)
    BNBContributed: any = '0';
    TRXContributed: any = '0';
}